module.exports = __webpack_public_path__ + "img/plan_b.6f43a3ba.png";